import { render, staticRenderFns } from "./ab-cust-dialog.vue?vue&type=template&id=641209d8&scoped=true"
import script from "./ab-cust-dialog.vue?vue&type=script&lang=js"
export * from "./ab-cust-dialog.vue?vue&type=script&lang=js"
import style0 from "./ab-cust-dialog.vue?vue&type=style&index=0&id=641209d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641209d8",
  null
  
)

export default component.exports